import type { SessionStateValue } from '@/api/types';
import { Pill } from './Pill';

const META: Record<SessionStateValue, { label: string; tone: 'up' | 'warn' | 'down' | 'neutral'; emoji: string }> = {
  OPEN: { label: '开仓中', tone: 'up', emoji: '✓' },
  WIND_DOWN: { label: '收尾中', tone: 'warn', emoji: '⚠' },
  LIQUIDATING: { label: '强平中', tone: 'down', emoji: '🔴' },
  CLOSED: { label: '平台未开放', tone: 'neutral', emoji: '·' },
};

export function SessionStateBadge({ state }: { state: SessionStateValue }) {
  const m = META[state];
  return (
    <Pill tone={m.tone}>
      <span className="num">{m.emoji}</span>
      {m.label}
    </Pill>
  );
}
